
<template>
  <!--新增小区-->
  <div>
  <x-addEdit
    ref="addEdit"
    :initReqHandle="false"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        ref="location"
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :lngLat="lngLat"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>

  </div>
</template>
<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [addEdit, fetchSelect],
  name: 'addCommunity',
  data () {
    let decoratorOptions = {
      communityName: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入小区名'},
          {pattern: this.REG.communityName, message: this.MESSAGE.communityName},
          {min: 2, max: 20, message: '小区名为2-20个字'}
        ]
      },
      areas: {
        rules: [{required: true, message: '请选择省市区'}]
      },
      propertyId: {
        rules: [{required: true, message: '请选择物业'}]
      },
      mapLng: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入经度'}]
      },
      mapLat: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入纬度'}]
      },
      address: {
        rules: [
          {required: true, message: '请输入小区地址'},
          {min: 2, max: 50, message: '小区地址为2-50个字'},
          {pattern: this.REG.addressName, message: this.MESSAGE.addressName}
        ]
      },
      telephone: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入管理处电话'},
          {pattern: this.REG.telephone, message: this.MESSAGE.telephone}
        ]
      },
      status: {initialValue: 1}
    };
    return {
      newAreas: undefined,
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      formList: [
        {
          label: '小区名',
          inputType: 'input',
          options: [],
          placeholder: '请输入小区名',
          props: ['communityName', decoratorOptions.communityName]
        },
        {
          label: '所在区域',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所在区域',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(1, 'formList', '1,2,3,4', e);
          },
          props: ['areas', decoratorOptions.areas]
        },
        {
          label: '所属物业',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属物业',
          props: ['propertyId', decoratorOptions.propertyId]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['mapLng', decoratorOptions.mapLng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['mapLat', decoratorOptions.mapLat]
            }
          ]
        },
        {
          label: '小区地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入小区地址',
          props: ['address', decoratorOptions.address]
        },
        {
          label: '管理处电话',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号或座机号',
          props: ['telephone', decoratorOptions.telephone]
        },
        {
          label: '标准地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入省市区街道和门牌上的道路名',
          props: ['standardAddress']
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        communityName: '',
        areas: '',
        propertyId: '',
        mapLng: '',
        mapLat: '',
        address: '',
        telephone: '',
        standardAddress: '',
        status: ''
      },
      addParam: {
        url: '/community',
        reqHandle: this.addReqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/community/',
        reqHandle: this.addReqHandle,
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/community/',
        resHandle: this.resHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /** region displayer 事件 */
    regionDisplayRender (labels) {
      this.regionChange(undefined, labels);
    },
    regionChange (val, selected) {
      let isArray = Array.isArray(val);
      if (isArray) { // 判断是change事件还是 displayRender
        console.log('community $refs: ', this.$refs.location);
        this.$refs.location && this.$refs.location.positionChanged();
      }

      if (selected && selected.length > 1) {
        let isCity = this.$store.state.citys.some(el => {
          return el === (isArray ? selected[0].label : selected[0]);
        });
        if (isCity) { // 判断是否为直辖市
          this.position = isArray ? selected[0].label : selected[0];
        } else {
          this.position = isArray ? selected[1].label : selected[1];
        }
      }
      if (val && selected && selected.length > 0) {
        let temp = [];
        selected.forEach(item => {
          let i = item.level - 1;
          temp[i] = item.value;
        });
        for (let i = 0; i < 4; i++) {
          if (temp[i] == undefined) {
            temp[i] = 0;
          }
        }
        this.newAreas = temp.toString();
      }
    },
    /* 获取下拉 */
    getSelect () {
      this.propertySelect(2, 'formList');
      this.newRegionSelect(1, 'formList', '1,2,3,4').then(() => {
        this.$route.query.id && this.$refs.addEdit.getDetail();
      });
    },
    resHandle (data) {
      let areas;
      if (data.areas) {
        areas = data.areas.split(',');
        this.newAreas = areas.toString();
        areas.forEach((i, index) => {
          if (i == 0) {
            areas.splice(index, 1);
          }
        });
        this.newRegionSelectByIds(1, areas, 4);
      }

      let formValues = {};
      let arr = [];
      data.areas && areas.forEach((el) => {
        arr.push((el));
      });
      formValues.areas = arr;

      if (data.mapLng && data.mapLat) {
        let lng = parseFloat(data.mapLng);
        let lat = parseFloat(data.mapLat);
        lng !== 0 && lat !== 0 && (this.lngLat = [lng, lat]);
      }
      // canChangeArea 是否可以修改小区所属地域： 0 否 1 是
      data.canChangeArea === 0 ? this.formList[1].disabled = true : this.formList[1].disabled = false;

      return formValues;
    },
    addReqHandle (res) {
      res.areas = this.newAreas;// res.areas.join(',');
      return res;
    },
    reqHandle (param) {
      return param;
    },
    detailResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
